// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from "./router"
import store from "./store"
// 引入svg图标
import "./assets/icons"

// 导入 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入 富文本编辑器 对应的样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';


// 引入全局样式表
import "./assets/css/global.css";
// 引用 ICOMOON 软件生成的字体
// import "./assets/fonts/font/style.css";
// 引用阿里矢量自己图标库
import "./assets/fonts/style.css";
import {MessageBox,Message} from "element-ui";
import {Form,FormItem,Input,Button} from "element-ui";
import {Container,Aside,Header,Main,Footer,Menu,Submenu,MenuItem,Breadcrumb,BreadcrumbItem
    ,Card,Row,Col,Upload,Dialog,Table,TableColumn,Pagination,Link,
    PageHeader,Switch,Tag,Select,Option,Checkbox,
    DatePicker,Loading,Tree,Divider, Autocomplete} from "element-ui";

/*Vue.prototype.openLoading = function() {
    const loading = this.$loading({           // 声明一个loading对象
        lock: true,                             // 是否锁屏
        text: '数据加载中',                     // 加载动画的文字
        spinner: 'el-icon-loading',             // 引入的loading图标
        background: 'rgba(0, 0, 0, 0.5)',       // 背景颜色
        target: '.el-table',                    // 需要遮罩的区域
        body: true,
        customClass: 'mask'                     // 遮罩层新增类名
    })
    setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close();                        // 关闭遮罩层
    },5000)
    return loading;
}*/
// 将 富文本编辑器 注册为全局可用的组件
Vue.use(VueQuillEditor, /* { default global options } */);


Vue.config.productionTip = false;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Link);
Vue.use(PageHeader);
Vue.use(Switch);
Vue.use(Tag);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(Tree);
Vue.use(DatePicker);
Vue.use(Autocomplete);
Vue.use(Divider);

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;



/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router, // 使用上vue-router
    store, // 使用上vuex
})



// WEBPACK FOOTER //
// ./src/main.js